import Component from '@glimmer/component';

export interface TabsComponentItem {
  label: string;
  active: boolean;
  onClick: (tabLabel: string) => void;
}

interface TabsComponentArgs {
  tabs: TabsComponentItem[];
}

export default class TabsComponent extends Component<TabsComponentArgs> {}
